import { Avatar } from 'components/user/Avatar';
import { UserName } from 'components/user/UserName';
import type { UserHit } from 'lib/algolia';
import { convertUserHit } from 'lib/algolia';

import { Suggestion } from '../Suggestion';

type Props = {
  hit: UserHit;
  isHighlighted: boolean;
};

export const UserSuggestion = ({ hit, isHighlighted }: Props) => {
  return (
    <Suggestion
      isHighlighted={isHighlighted}
      avatar={<Avatar user={convertUserHit(hit)} size={5} />}
      primary={<UserName user={convertUserHit(hit)} />}
    />
  );
};
